import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { EditCompanyForm } from '@/features/company'
import { useCompany } from '@/shared/api/company'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'
import { OffcanvasSkeleton } from '@/shared/ui/offcanvas-skeleton'

export const Route = createFileRoute(
  '/_auth/administration/reference-books/company/update/$companyId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { companyId } = Route.useParams()
  const { data: company, isLoading } = useCompany({ id: companyId })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактировать организацию')}>
      {isLoading ? (
        <OffcanvasSkeleton />
      ) : company?.company ? (
        <EditCompanyForm onClose={close} company={company.company} />
      ) : (
        <div>{t('Ошибка загрузки данных организации')}</div>
      )}
    </Offcanvas>
  )
}
